import {
  REQUEST_FUNERAL_LIST
  ,REQUEST_CAMPAIGN_LIST
  ,REQUEST_INVITATION_DETAIL
  ,REQUEST_CAMPAIGN_DETAIL
} from './mutation-types';

export default {
  [REQUEST_FUNERAL_LIST] (state, receivedData) {
    state.funerals = receivedData.content;
    state.funeralCount = receivedData.totalElements;
  },
  [REQUEST_CAMPAIGN_LIST] (state, receivedData) {
    state.funerals = receivedData.content;
    state.funeralCount = receivedData.totalElements;
  },
  [REQUEST_INVITATION_DETAIL] (state, receivedData) {
    state.invitation = receivedData;
  },
  [REQUEST_CAMPAIGN_DETAIL] (state, receivedData) {
    state.campaign = receivedData;
  }
}